import type { IWisDetailsModalAssesmentsProps } from './types'
import WisDetailsModalHeading from './Heading'
import WisDetailsAccordion from './Accordion'
import WisDetailsModalScenario from './Scenario'

export const WisDetailsModalAssesments = ({
  currentState
}: IWisDetailsModalAssesmentsProps) => {
  return (
    <div>
      <WisDetailsModalHeading>What-If Scenarios</WisDetailsModalHeading>
      <div className='px-6 pb-2'>
        {currentState.assessments?.map((assessment) => (
          <WisDetailsAccordion scenario={assessment} key={assessment.id}>
            <WisDetailsModalScenario
              isInAccordion
              currentState={currentState}
              assessment={assessment}
            />
          </WisDetailsAccordion>
        ))}
      </div>
    </div>
  )
}

export default WisDetailsModalAssesments
